// user-sync.service.ts
import { Injectable, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { unauthenticateUser } from '../store/user/user.actions';

@Injectable({ providedIn: 'root' })
export class LoginSyncService {
  private channel?: BroadcastChannel;

  constructor(
    private store: Store,
    private zone: NgZone
  ) {
    if ('BroadcastChannel' in window) {
      this.channel = new BroadcastChannel('auth');
      this.channel.onmessage = (msg) => {
        if (msg.data === 'logout') {
          // Dispatch in Angular zone so UI updates
          this.zone.run(() => this.store.dispatch(unauthenticateUser()));
        }
      };
    }
  }

  broadcastLogout() {
    try {
      this.channel?.postMessage('logout');
    } catch {
      // Deliberately ignored: notifying other tabs is best-effort. A closed or
      // unavailable BroadcastChannel must not prevent this tab from logging out.
    }
  }
}
